import $ from '@/util/jQuery';
import { betweenParenthesis, getIncomeAmount } from '@/util/String';

/**
  Given a standard STHS HTML Output, will pull the date
  @params html - The STHS HTML Output
  @returns { string } - The date in string format 
*/
export function getDateFromHTMLOutput(html){
  const string = $(html).closest(".STHSBoxScore_NowTime").text();
  let date = string.split(' -  ')[1]
  
  return date.split(' at ')[0]; 
}

/**
  Given a standard STHS HTML Output, will pull the game officials
  @params html - The STHS HTML Output
  @returns { object } - Object with keys linesman and referees
*/
export function getGameOfficialsFromHTMLOutput(html){
  const officials = $(html).find(".STHSBoxScore_PeriodPerPeriod_Header").filter((_, el) => ['Official'].includes(el.innerHTML))[0];
  
  let [referees, linesman] = Array.prototype.slice.call($(officials).parent().next('tr').children('td')[1].childNodes)
    .filter(node => node.nodeName !== "BR")
    .filter(node => node.textContent.replace(/\n/g, '') !== "")
    .map(node => node.textContent.replace(/\n/g, ''))

  if(referees.includes("Unknown")) {
    referees = ["Unknown"];
  } else {
    referees = referees.replace('Referees : ', '');
    referees = referees.split(' and ');
  }

  if(linesman.includes("Unknown")) {
    linesman = ["Unknown"];
  } else {
    linesman = linesman.replace('Linesman : ', '');
    linesman = linesman.split(' and ');
  }

  return {
    referees,
    linesman
  }
}

/**
  Given a standard STHS HTML Output, will pull the three stars of the game
  @params html - The STHS HTML Output
  @returns { array } - The names of the three stars
*/
export function getThreeStarsFromHTMLOutput(html){
  let stars = $(html).find(".STHSBoxScore_PeriodPerPeriod_Header").filter((_, el) => ['3 Stars'].includes(el.innerHTML))[0];
  
  stars = Array.prototype.slice.call($(stars).parent().next('tr').children('td')[0].childNodes)
    .filter(node => node.nodeName !== "BR")
    .filter(node => node.textContent.replace(/\n/g, '') !== "")
    .map(node => node.textContent.replace(/\n/g, ''))

  return stars.map(star => star.split(' - ')[1].split(' (')[0].trim());
}

/**
  Given a standard STHS HTML Output, will pull the game officials
  @params html - The STHS HTML Output
  @returns { object } - Object with keys linesman and referees
*/
export function getVenueStatsFromHTMLOutput(html){
  let venue = $(html).find(".STHSBoxScore_PeriodPerPeriod_Header").filter((_, el) => ['Finance'].includes(el.innerHTML))[0];

  venue = Array.prototype.slice.call($(venue).parent().next('tr').children('td')[0].childNodes)
    .filter(node => node.nodeName !== "BR")
    .filter(node => node.textContent.replace(/\n/g, '') !== "")
    .map(node => node.textContent.replace(/\n/g, ''))

  // The output is always the same... should always be a 9 item array
  // First five are attendance and income by section
  const sections = venue.splice(0, 5).map(parseSection);

  // Next is Rink
  const rink = parseRink(venue.splice(0, 1)[0]);

  // Then total attendance
  const totalAttendance = parseTotalAttendance(venue.splice(0, 1)[0])

  // Income breakdown
  const income = venue.splice(0, 1).map(parseIncome)[0]

  return {
    rink,
    attendance: {
      sections: sections.map(section => ({ name: section.name, total: section.attendance.total, pct: section.attendance.pct })),
      total: totalAttendance,
    },
    income:{
      sections: sections.map(section => ({ name: section.name, income: section.income })),
      total: income.amount,
    }
  }
}


/**
  Given a standard STHS HTML Output of a section string, 
  will pull the name, income and attendance of the section
*/
function parseSection(text){
  let [name, attendance, income] = text.split(' -- ');
  
  // Format income.. Ticket Income $930,864
  income = parseInt(income.split(' $')[1].replace(',',''));

  // Format attendance.. Attendance: 5676 (91.40%)
  attendance = parseAttendance(attendance);

  return {
    name,
    income,
    attendance
  }
}

/**
  Given a standard STHS HTML Output of a venue string, 
  will pull the name of the venue
*/
function parseRink(text){
  return text.replace('Game was played at the ', '').replace('.', '')
}

/**
  Given a standard STHS HTML Output of a total attendance string, 
  will pull the total attendance number
*/
function parseTotalAttendance(str) {
  const [, amount, pct] = str.replace('Total ', '').split(' ');
  return {
    amount: parseInt(amount),
    pct: parseFloat(betweenParenthesis(pct).replace('%', ''))
  }
}

/**
  Given a standard STHS HTML Output of an attendance string, 
  will pull the total and percentage
  Ex: Attendance: 5676 (91.40%)
  Ex: Total Attendance: 17277 (92.74%)
*/
function parseAttendance(attendance) {
  let str = attendance.replace('Total ', '');
  let [, total, pct] = str.split(' ');

  return {
    total: parseInt(total),
    pct: parseFloat(betweenParenthesis(pct).replace('%', ''))
  }
}


/**
  Given a standard STHS HTML Output of a the income string, 
  will pull the various income statements
  Ex: Total Ticket Income: $2,140,875
  Ex: Other Income:  $214,088
*/
function parseIncome(str, i) {
  const name = i === 0 ? 'Ticket' : 'Other';
  const amount = getIncomeAmount(str);

  return {
    name,
    amount
  }
}

export default {
  getDateFromHTMLOutput,
  getThreeStarsFromHTMLOutput,
}